import React from 'react';
import { styled } from "@mui/material/styles";

import StoreLocalization from '@/storeLocator/components/StoreLocalization/StoreLocalization';
import { HeroSectionProps } from './types';

const StyledHero = styled("div")<{ imageUrl: string }>(({ imageUrl, theme }) => ({
    width: "100%",
    height: "250px",
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center 50%",
    display: "flex",
    [theme.breakpoints.up("md")]: {
        height: "512px"
    }
  }));

export const HeroSection = ({heroSection, handleOpenLocalizationRail}: HeroSectionProps) => { 
    const {
        title,
        description,
        buttonText,
        image
    } = heroSection;

    return (
        <StyledHero imageUrl={image}>
            <StoreLocalization 
                title={title} 
                description={description} 
                buttonText={buttonText} 
                handleOpenLocalizationRail={handleOpenLocalizationRail} 
            />
        </StyledHero>
    );
};

export default HeroSection;